var _a;
import { TransactionStatus } from '../const/transactionStatus';
var temporaryCreditHasBeenApplied = 'transactionDisputeStatusDescription.temporaryCreditHasBeenApplied';
var ifNewInformationIsReceived = 'transactionDisputeStatusDescription.ifNewInformationIsReceived';
var weAppliedACredit = 'transactionDisputeStatusDescription.weAppliedACredit';
var basedOnTheInformation = 'transactionDisputeStatusDescription.basedOnTheInformation';
var TransactionDisputeDescriptionTitleKeys = (_a = {},
    _a[TransactionStatus.SET_1] = [
        'transactionDisputeStatusDescription.set1Description'
    ],
    _a[TransactionStatus.SET_2] = [
        'transactionDisputeStatusDescription.set2Description'
    ],
    _a[TransactionStatus.SET_3] = [
        'transactionDisputeStatusDescription.set2Description'
    ],
    _a[TransactionStatus.SET_4] = [
        'transactionDisputeStatusDescription.set4DescriptionLine1',
        'transactionDisputeStatusDescription.set4DescriptionLine2'
    ],
    _a[TransactionStatus.SET_5] = [
        temporaryCreditHasBeenApplied,
        ifNewInformationIsReceived
    ],
    _a[TransactionStatus.SET_6] = [
        temporaryCreditHasBeenApplied,
        ifNewInformationIsReceived
    ],
    _a[TransactionStatus.SET_7] = [
        temporaryCreditHasBeenApplied,
        ifNewInformationIsReceived
    ],
    _a[TransactionStatus.SET_8] = [
        'transactionDisputeStatusDescription.set8DescriptionLine1',
        'transactionDisputeStatusDescription.set8DescriptionLine2'
    ],
    _a[TransactionStatus.SET_9] = [weAppliedACredit],
    _a[TransactionStatus.SET_10] = [weAppliedACredit],
    _a[TransactionStatus.SET_11] = [
        'transactionDisputeStatusDescription.set11Description'
    ],
    _a[TransactionStatus.SET_12] = [weAppliedACredit],
    _a[TransactionStatus.SET_13] = [weAppliedACredit],
    _a[TransactionStatus.SET_14] = [basedOnTheInformation],
    _a[TransactionStatus.SET_15] = [basedOnTheInformation],
    _a[TransactionStatus.SET_16] = [basedOnTheInformation],
    _a[TransactionStatus.SET_17] = [basedOnTheInformation],
    _a[TransactionStatus.SET_18] = [basedOnTheInformation],
    _a[TransactionStatus.SET_19] = [
        'transactionDisputeStatusDescription.set11Description'
    ],
    _a[TransactionStatus.SET_20] = [basedOnTheInformation],
    _a[TransactionStatus.SET_21] = [
        'transactionDisputeStatusDescription.set21Description'
    ],
    _a[TransactionStatus.SET_22] = [
        'transactionDisputeStatusDescription.set22Description'
    ],
    _a[TransactionStatus.SET_23] = [
        'transactionDisputeStatusDescription.set23Description'
    ],
    _a[TransactionStatus.SET_24] = [
        'transactionDisputeStatusDescription.set24Description'
    ],
    _a[TransactionStatus.SET_25] = [
        'transactionDisputeStatusDescription.set25Description'
    ],
    _a);
var getTranslationForTransactionDisputeDescription = function (status) {
    var description = TransactionDisputeDescriptionTitleKeys[status];
    if (!description)
        return [];
    return description;
};
export default getTranslationForTransactionDisputeDescription;
//# sourceMappingURL=getTranslationForTransactionDisputeDescription.js.map